/*
As default, one channel received should be decoded to a single object with properties 'channels' and 'location'.
  Ax34f54: { channels: ['DESKTOP', 'MOBILE'], location: '/home' },
If needed, one channel can be decoded to several object in an array. Example:
  Ax34f54: [
    { channels: ['DESKTOP', 'POPUP', 'MOBILE'], location: '/home' },
    { channels: ['DESKTOP', 'MOBILE'], location: '/search' },
    { channels: 'POPUP', location: '/on-offer' },
  ]
Used the following channels to set the behaviour of the message, more than one could be used at the same time in an array:
  DESKTOP - static desktop notifications used by the component DesktopNotification
  POPUP - popup notifications for desktop version used by the component PopupNotification
  MOBILE - popup notifications for mobile version used by the component PopupNotification
*/
export const casesToDecode = (shouldDisplayDesktopAsPopup) => ({
  DESKTOP_LOGGED_IN_HOMEPAGE: {
    channels: shouldDisplayDesktopAsPopup ? 'POPUP' : 'DESKTOP',
    location: '/home',
  },
  POPUP_LOGGED_IN_HOMEPAGE: { channels: 'POPUP', location: '/home' },
  MOBILE_LOGGED_IN_HOMEPAGE: { channels: 'MOBILE', location: '/home' },
});
